<template>
  <el-dialog
    title="证照借用"
    :visible.sync="visible"
    width="1300px"
      top='5vh'
    :before-close="onClose"
  >
    <div>
      <el-tabs v-model="activeName" class="borrow">
        <el-tab-pane label="原件借用" name="first">
          <div>
            <span>预计归还日期: </span>
            <el-date-picker v-model="date" type="date" />
            <el-button style="margin-left:15px" size="medium" type="primary" @click="handleSubmit('')">借用</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="项目挂靠" name="second">
              <el-form :model="form" ref="ruleForm" inline>
      <el-row>
        <el-col :span="8">
          <el-form-item label="工程名称:" prop="project_name">
                  <el-input v-model="form.project_name"/>
          </el-form-item>
        </el-col>
        <el-col :span="16" class="action">
            <el-button size="small" type="primary" @click="submitForm" plain>查询</el-button>
            <el-button size="small" @click="resetForm">重置</el-button>
        </el-col>
      </el-row>
    </el-form>
            <STable :columns="columns" :loadData="loadData" ref="table">
              <template #sn='{ $index }'>
                {{ $index + 1 }}
              </template>
              <template #action="record">
                  <a href="javascript:;" @click="handleSubmit(record.row.project_name)">借用</a>
              </template>
            </STable>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>

<script>
import STable from '@/components/STable';
import { initUserInfo } from '@/store/utils';
import { LicenseBorrowingAndReturning, LicenseManagement } from '@/api/Licence'
export default {
  props: {
    visible: {
      type: Boolean,
      required: false
    },
    record: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    STable
  },
  data () {
    return {
      activeName: 'first',
      date: '',
      form: {
        project_name: ''
      },
      columns: [
        {
          label: '序号',
          scopedSlots: 'sn',
          width: 100
        },
        {
          label: '工程名称',
          prop: 'project_name',
          ellipsis: true,
          width: 300
        },
        {
          label: '工程规模(万元)',
          // align: 'center',
          prop: 'project_scale',
          ellipsis: true,
          width: 200
        },
        {
          label: '工程性质',
          prop: 'project_nature',
          // align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          label: '实际开工日期',
          prop: 'actual_start_date',
          // align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          label: '实际竣工日期',
          prop: 'actual_end_date',
          // align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          label: '项目负责人',
          prop: 'project_leader',
          // align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          label: '合同起始日期',
          prop: 'contract_start_date',
          // align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          label: '合同截止日期',
          prop: 'contract_end_date',
          // align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          label: '操作',
          scopedSlots: 'action',
          width: 150,
          fixed: 'right',
          ellipsis: true
        }
      ],
      loadData: (pageParam) => {
        const arr = []
        for (var key in this.form) {
          if (this.form[key]) {
            arr.push({
              columnName: key,
              columnValue: this.form[key],
              filterType: 3,
              tableName: 'oa_form_project_info'
            })
          }
        }
        return LicenseBorrowingAndReturning.getProjectList(this, {datasourceId: '1630028404818448384', filterDtoList: arr, pageParam }).then(rs => rs)
      },
      name: initUserInfo().userId
    };
  },
  watch: {
    visible (val) {
      if (val) {
        
        this.resetForm()
      }
    }
  },
  created () {
  },
  methods: {
    handleSubmit (projectName) {
      if (!this.date && this.activeName === 'first') {
        this.$message({
          message: '请选择预计归还时间',
          type: 'warning'
        });
        return
      }
      const masterData = {
        license_id: this.record.license_id,
        user_id: this.record.staff_name * 1,
        return_time: this.activeName === 'first' ? this.date : null,
        approve: this.name,
        allow: 0,
        type: this.activeName === 'first' ? '原件借用' : '项目挂靠'
      }
      if (projectName) {
        masterData.project_name = projectName
        const data = {
          datasourceId: '1631157465292738560',
          masterData: {
            ...this.record,
            project_name: projectName
          }
        }
        this.record.project_name = projectName
        LicenseManagement.updateLicenser(this, data).then(res => {
        })
      }
      LicenseBorrowingAndReturning.createdBorrow(this, {datasourceId: '1631203503424671745', masterData}).then(res => {
        this.$message({
          message: '已发出申请,请等待审批结果!',
          type: 'success'
        });
        this.$emit('submitForm', false);
        this.onClose()
      })
    },
    onClose () {
      this.$emit('update:visible', false);
    },
    onDialogClose () {
      // 还好保留一个遮罩，直接移除
      const tag = document.querySelector('.checkList .v-modal');
      if (tag) tag.remove();
    },
    submitForm (flag = true) {
      if (this.$refs.table) this.$refs.table.refresh(flag)
    },
    resetForm () {
      this.form = {
        project_name: ''
      }
      this.submitForm()
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
